export const InsCheckTypeEnums = {
  PATIENT_IDENTITY: 'patient_identity',
  VITAL_CARD: 'vital_card',
}
